import MToolbarTitle from "./MToolbarTitle.vue";
export default MToolbarTitle;
export type { MToolbarTitleProps } from "./MToolbarTitle.props";
